/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GenderNeuter(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,104a80,80,0,1,0-88,79.59912V232a8,8,0,0,0,16,0V183.59912A80.1104,80.1104,0,0,0,208,104Zm-80,64a64,64,0,1,1,64-64A64.07239,64.07239,0,0,1,128,168Z" />
    </Svg>
  );
}

export default GenderNeuter;
